/* istanbul ignore file */
export default async function externalComponent(name) {
	// If we're running in development mode, load the non-minified plugin
	let fileExtension = process.env.NODE_ENV === "development" ? ".umd.js" : ".umd.min.js";

	// Use pathname as the base URL, as we can be under /immixcc/
	let url = `${window.location.pathname}plugins/${name}`;
	let pluginPath = `${url}${fileExtension}`;
	let stylesPath = `${url}.css`;

	if (window[name]) return window[name];

	window[name] = new Promise((resolve, reject) => {
		const script = document.createElement(`script`);
		script.async = true;
		script.addEventListener(`load`, () => {
			resolve(window[name]);
		});
		script.addEventListener(`error`, () => {
			reject(new Error(`Error loading ${pluginPath}`));
		});
		script.src = pluginPath;
		document.head.appendChild(script);

		let cssLink = document.createElement("link");
		cssLink.rel = "stylesheet";
		cssLink.href = stylesPath;
		document.head.appendChild(cssLink);
	});

	return window[name];
}
